<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
              <undertime-request>
              </undertime-request> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import undertimeRequest from './todo-undertime-request'
    export default {
        components: {
            undertimeRequest
        }
    }
    </script>
    <style lang="scss">
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-undertime-request.vue